import React from "react";
import { useI18n } from "../i18n";

export default function TopDisclaimerBar() {
  const { d } = useI18n();
  return (
    <div
      data-testid="top-disclaimer-bar"
      role="note"
      className="relative z-40 bg-jlo-red text-jlo-warm text-[11px] sm:text-xs font-semibold tracking-[0.14em] uppercase text-center px-4 py-2 leading-snug"
    >
      {d.disclaimer.bar}
    </div>
  );
}
